import * as _ from "lodash";
import { ProviderRepo } from "@services/fileprovider.repo";
import { ClientRepo } from "@services/clients/client.repo";
import {
  ExternalSourceName,
  ExternalSourcesList,
} from "@common/enums/ExternalSources";
import * as moment from "moment";
import { Constants } from "@constants/shared";
import { extractErrorMessage } from "@common/utils/errorUtils";

class fileListController implements angular.IOnInit {
  public files: String[];
  public searchText: string;
  public selectedUsername: string;
  public password: String;
  public latestPVDate;
  public latestMCBPVDate;
  public latestEDRPVDate;
  public latestMCBEOMDate;
  public MCBExternalSourceName = ExternalSourceName.MCB;
  public EDRExternalSourceName = ExternalSourceName.EDR;
  public MCBReceived: string;
  public EDRReceived: string;
  public MCBTimeFrame: number;
  public EDRTimeFrame: number;
  public MCBReceivedTime: string;
  public EDRReceivedTime: string;
  public genericFileList: any[];
  public selectedReprocessProvider: string = "";
  public backfillFromDate: Date = new Date();
  public backfillMaxDate: Date = new Date();
  public backfillProcessing: boolean = false;

  /** @ngInject */
  constructor(
    private providerRepo: ProviderRepo,
    private clientRepo: ClientRepo,
    private $state: angular.ui.IStateService,
    private notifyjs: any
  ) {}

  $onInit() {
    this.populateFileData();
    this.getLatestPVDate();
  }

  populateFileData() {
    this.files = [];
    this.providerRepo
      .getFiles()
      .then((files) => {
        this.files = files;
      })
      .catch((err) => this.notifyjs(`Failed to retrieve file: ${extractErrorMessage(err)}`));
  }

  getPassword(event: angular.IAngularEvent, user) {
    if (user === this.selectedUsername) {
      this.selectedUsername = "";
    } else {
      this.selectedUsername = user;
      this.providerRepo
        .getPassword(user)
        .then((password) => {
          this.password = password.password;
        })
        .catch((err) => this.notifyjs(`Failed to retrieve password: ${extractErrorMessage(err)}`));
    }
  }

  getPasswordButtonTitle(username) {
    if (username === this.selectedUsername) {
      return "Hide Password";
    }
    return "Get Password";
  }

  displayPassword(username) {
    if (username === this.selectedUsername) {
      return this.password;
    }
    return "****";
  }

  viewFileDetails(username) {
    this.$state.go("root.fileproviders.details", { username: username });
  }

  createNewFile() {
    this.$state.go("root.fileproviders.create");
  }

  getLatestPVDate() {
    this.clientRepo
      .getLatestPVDates()
      .then((res) => {
        let dataFeedData: any = res.data;
        this.latestMCBPVDate = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.MCBExternalSourceName &&
                  !dataFeed.isReconciled
                );
              })
            ).fileDate
          )
        ).format("DD-MM-YYYY");
        var startTimeMCB = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.MCBExternalSourceName &&
                  !dataFeed.isReconciled
                );
              })
            ).dateStarted
          )
        );
        var endTimeMCB = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.MCBExternalSourceName &&
                  !dataFeed.isReconciled
                );
              })
            ).dateCompleted
          )
        );
        this.latestEDRPVDate = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.EDRExternalSourceName
                );
              })
            ).fileDate
          )
        ).format("DD-MM-YYYY");
        var startTimeEDR = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.EDRExternalSourceName
                );
              })
            ).dateStarted
          )
        );
        var endTimeEDR = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.EDRExternalSourceName
                );
              })
            ).dateCompleted
          )
        );
        this.latestMCBEOMDate = _.first(
          _.filter(dataFeedData, (dataFeed) => {
            return (
              dataFeed.dataFeedSourceName === this.MCBExternalSourceName &&
              dataFeed.isReconciled
            );
          })
        );

        let fileDates = dataFeedData
          .filter((feed) => {
            return !feed.isReconciled;
          })
          .map((feed) => {
            return moment(new Date(feed.fileDate));
          });

        this.latestPVDate = moment.max(fileDates).format("DD-MM-YYYY");

        var durationMCB = moment.duration(endTimeMCB.diff(startTimeMCB));
        this.MCBTimeFrame = durationMCB.asMinutes();
        var durationEDR = moment.duration(endTimeEDR.diff(startTimeEDR));
        this.EDRTimeFrame = durationEDR.asMinutes();
        // this.latestPVDate = moment(new Date()).format("YYYY-MM-DD");
      })
      .then(() => {
        this.getLatestAllDates();
      });
  }

  getLatestAllDates() {
    this.clientRepo
      .getLatestGenericPVDates(this.latestPVDate)
      .then((res) => {
        let dataFeedData: any = res.data;
        this.genericFileList = dataFeedData;
        let fileDates = dataFeedData
          .filter((feed) => {
            return !feed.isReconciled;
          })
          .map((feed) => {
            return moment(new Date(feed.fileDate));
          });
        if (fileDates.length > 0) {
          var newlatestPVDate = moment.max(fileDates).format("DD-MM-YYYY");
          var oldLatestPVDate = this.latestPVDate;
          this.latestPVDate = moment
            .max([moment(newlatestPVDate, "DD-MM-YYYY"), moment(oldLatestPVDate, "DD-MM-YYYY")])
            .format("DD-MM-YYYY");
        }
      })
      .then(() => {
        this.providerRepo
          .checkFileReceived("MCB", this.latestPVDate)
          .then((val) => {
            if (val === "false") this.MCBReceived = "No";
            else {
              let received = val.split("/");
              if (received[received.length - 1] == "3") {
                this.MCBReceivedTime = null;
                this.MCBReceived = val;
              } else {
                this.MCBReceivedTime = val;
                this.MCBReceived = "Yes";
              }
            }
          })
          .catch((err) =>
            this.notifyjs(`Failed to retrieve file: ${extractErrorMessage(err)}`)
          );

        this.providerRepo
          .checkFileReceived("EDR", this.latestPVDate)
          .then((val) => {
            if (val === "false") this.EDRReceived = "No";
            else {
              let received = val.split("/");
              if (received[received.length - 1] == "2") {
                this.EDRReceivedTime = null;
                this.EDRReceived = val;
              } else {
                this.EDRReceivedTime = val;
                this.EDRReceived = "Yes";
              }
            }
          })
          .catch((err) =>
            this.notifyjs(`Failed to retrieve file: ${extractErrorMessage(err)}`)
          );
      });
  }

  getFileStatus(type) {
    var today = moment(new Date());
    // var today = moment("2021-08-03 09:07:00");
    if (type === "MCB") {
      // if () check time frame and file received
      if (!this.checkLatestDate(this.latestMCBPVDate)) {
        if (this.MCBReceived !== "Yes") {
          return "Files Not Received";
        } else {
          var duration = moment.duration(
            today.diff(moment(this.MCBReceivedTime))
          );
          if (duration.asMinutes() < this.MCBTimeFrame + 10) {
            return "Potentially Processing";
          }
          //check timeframe
        }
        return "Unprocessed";
      }
      return "Up to Date";
    } else if (type === "EDR") {
      // if () check time frame and file received
      if (!this.checkLatestDate(this.latestEDRPVDate)) {
        if (this.EDRReceived !== "Yes") {
          return "Files Not Received";
        } else {
          var duration = moment.duration(
            today.diff(moment(this.EDRReceivedTime))
          );
          if (duration.asMinutes() < this.EDRTimeFrame + 10) {
            return "Potentially Processing";
          }
        }
        return "Unprocessed";
      }
      return "Up to Date";
    } else {
      let dataFeedFilter = this.genericFileList.filter(
        (feed) => feed.dataFeedSourceName === type
      );
      let dataFeed = dataFeedFilter[0];
      if (dataFeed.fileReceived === "false") {
        return "Files Not Received";
      }
      let dataFeedArray = dataFeed.fileReceived.split("-");
      let waiting = 0,
        processing = 0,
        processed = 0;
      waiting = parseInt(dataFeedArray[0].split(":")[1]);
      processing = parseInt(dataFeedArray[1].split(":")[1]);
      processed = parseInt(dataFeedArray[2].split(":")[1]);

      if (processed == 0 && processing == 0) {
        return "Unprocessed";
      }
      if (processing > 0) {
        return "Files are being processed";
      }
      if (processed > 0 && processing == 0 && waiting == 0) {
        return "Up to Date";
      }

      return dataFeed.fileReceived;
    }
  }

  getFileReceivedStatus(status) {
    if (status === "false") return "No";
    else {
      if (!status.includes("/") || !status.includes(":")) {
        return "Yes";
      } else {
        let dataFeedArray = status.split("-");
        let waiting = 0,
          processing = 0,
          processed = 0;
        waiting = parseInt(dataFeedArray[0].split(":")[1]);
        processing = parseInt(dataFeedArray[1].split(":")[1]);
        processed = parseInt(dataFeedArray[2].split(":")[1]);
        let total = waiting + processing + processed;

        if (total >= 3) {
          return "Yes";
        }

        return `${total}/3`;
      }
    }
  }

  checkLatestDate(date) {
    if (this.latestPVDate === date) {
      return true;
    }
    return false;
  }

  getFileReceived(provider) {
    if (this.getFileStatus(provider) !== "Up to Date") {
      return true;
    }
  }

  rerunFile(event: angular.IAngularEvent, provider) {
    let timeframe = 0;
    if (provider === "MCB") {
      timeframe = this.MCBTimeFrame;
    } else if (provider === "EDR") {
      timeframe = this.EDRTimeFrame;
    } else {
      let dataFeedFilter = this.genericFileList.filter(
        (feed) => feed.dataFeedSourceName === provider
      );
      let dataFeed = dataFeedFilter[0];
      timeframe = moment
        .duration(
          moment(dataFeed.dateCompleted).diff(moment(dataFeed.dateStarted))
        )
        .asMinutes();
    }
    timeframe = Math.round(timeframe + 10);
    this.notifyjs(
      `Files are being rerun, please allow for ${timeframe} minutes for the process to finish.`
    );
    this.providerRepo.rerunFiles(provider, this.latestPVDate);
  }

  convertDataReconciled(date) {
    return moment(new Date(date)).format("DD-MM-YYYY");
  }

  isUAT(): boolean {
    return Constants.getEnvironment() !== Constants.PROD;
  }

  processFromDate(event: angular.IAngularEvent) {
    if (!this.selectedReprocessProvider) {
      this.notifyjs("Please select a provider.", "warning");
      return;
    }
    if (!this.backfillFromDate) {
      this.notifyjs("Please select a from date.", "warning");
      return;
    }
    const provider = this.selectedReprocessProvider;
    const fromDate = moment(this.backfillFromDate).format("YYYY-MM-DD");
    this.backfillProcessing = true;
    this.notifyjs(
      `${provider} reprocessing started from ${fromDate}. This may take several minutes.`,
      "info"
    );
    this.providerRepo
      .processFilesFromDate(provider, fromDate)
      .then((response) => {
        this.backfillProcessing = false;
        this.notifyjs(`${provider} reprocessing from ${fromDate} completed.`, "success");
      })
      .catch((err) => {
        this.backfillProcessing = false;
        this.notifyjs(`${provider} reprocessing failed: ${extractErrorMessage(err)}`, "error");
      });
  }
}

export const fileList: angular.IComponentOptions = {
  template: require("./fileList.html"),
  controller: fileListController,
};



// WEBPACK FOOTER //
// ./src/app/fileprovider/fileList.ts